module.exports = __webpack_public_path__ + "media/images/logo_side-1fb2c7fc.png";